import type { LucideIcon } from "lucide-react";

import styles from "./styles.module.css";

interface ParameterCardProps {
  icon: LucideIcon;
  name: string;
  description: string;
}

export function ParameterCard({ icon: Icon, name, description }: ParameterCardProps) {
  return (
    <article className={styles.card} data-reveal>
      <span className={styles.iconWrap}>
        <Icon size={20} strokeWidth={1.6} />
      </span>
      <h3 className={styles.name}>{name}</h3>
      <p className={styles.desc}>{description}</p>
    </article>
  );
}

export default ParameterCard;
